import React, { useEffect, useState } from "react";
import API from "../../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import Loading from "../../../Loading/loading";
import AdminView from "../../../Assets/img/Eye.svg";
import Search from "../../../Assets/img/search.png";
import Edit from "../../../Assets/img/Edit.svg";
import { useLocation } from "react-router-dom";
import Calendar from "../../../Assets/img/calendar.png";
const OldConsultationFromList = () => {
    const [candidate, setCandidate] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const [selectedAction, setSelectedAction] = useState("");
    const [selectedId, setSelectedId] = useState(null);
    const location = useLocation();
    const [pageNumber, setPage] = useState(1);
    const rowsPerPage = 10;
    const [totalPages, setTotalPages] = useState(1);
    const [immigration, setImmigration] = useState("");
    const [consultation, setConsultation] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [immigrationType, setImmigrationType] = useState([]);
    const [consultationType, setConsultationType] = useState([]);
    const [bookingStatusCondition, setBookingStatusCondition] = useState("");
    const customerFieldMap = {
        1: { // English
            name: "full_name",
            email: "email",
            mobile: "mobile_number"
        },
        2: { // French
            name: "nom_et_prénom",
            email: "e_-mail",
            mobile: "numéro_de_portable"
        }
    };
    const consultationStatusMap = {
        Confirmed: {
            en: "Confirmed",
            fr: "Confirmé",
        },
        New: {
            en: "New",
            fr: "Nouveau",
        },
        "Payment Request": {
            en: "Payment Request",
            fr: "Demande de paiement",
        }
    };
    const getConsultationStatusLabel = (bookingStatusCondition, languageId) => {
        if (!bookingStatusCondition) return "--";

        const lang = languageId === 1 ? "en" : "fr";

        return consultationStatusMap[bookingStatusCondition]?.[lang] || bookingStatusCondition;
    };

    const fetchimmigration = (langId = languageId) => {
        API.post("listofservicelist/condition", { language_id: langId })
            .then((res) => {
                const immigrationData = res?.data?.data?.data || [];
                setImmigrationType(immigrationData);
            })
            .catch((err) => console.error("Failed to fetch immigration types:", err));
    };

    const fetchconsultation = (langId = languageId) => {
        API.post("consultationtypelist/condition", { language_id: langId })
            .then((res) => {
                const consultationData = res?.data?.data || [];
                setConsultationType(consultationData);
            })
            .catch((err) => console.error("Failed to fetch consultation types:", err));
    };
    useEffect(() => {
        fetchimmigration(languageId);
        fetchconsultation(languageId);
    }, [languageId]);

    const fetchConsultationList = () => {
        setLoading(true);

        API.post("ConsultationCustomerList/condition", {
            pageNumber,
            rowsPerPage,
            language_id: languageId,
            search,
            listofservice_id: immigration,
            consultation_type_id: consultation,
            consultation_status: bookingStatusCondition,
            from_date: fromDate,
            to_date: toDate,
        })
            .then((response) => {
                const resData = response.data?.data;
                const list = resData?.data || [];
                const totalRecords = resData?.totalRecords || 0;

                setTotalPages(Math.ceil(totalRecords / rowsPerPage));

                const formatted = list.map((item) => {
                    const map = customerFieldMap[languageId];

                    return {
                        id: item.consultation_booking_id,
                        firstName: item.customer?.[map.name] || "--",
                        email: item.customer?.[map.email] || "--",
                        mobile: item.customer?.[map.mobile] || "--",
                        heading: item.heading || "--",
                        consultationType: item.consultation_type_name || "--",
                        bookingDate: item.booking_date || "--",
                        start_time: item.start_time || "--",
                        end_time: item.end_time || "--",
                        admin_date: item.admin_date || "--",
                        admin_start_time: item.admin_start_time || "--",
                        admin_end_time: item.admin_end_time || "--",
                        status: getConsultationStatusLabel(
                            item.consultation_status,
                            item.language_id
                        ),

                         originalStatus: item.consultation_status,

                    };
                });

                setCandidate(formatted);
            })
            .catch((err) => console.error("Error fetching consultation list:", err))
            .finally(() => setLoading(false));
    };

    // useEffect(() => {
    //     setPage(1);
    //     fetchConsultationList();
    // }, [immigration, consultation, fromDate, toDate]);

    useEffect(() => {
        fetchConsultationList();
    }, [pageNumber, languageId]);

    const handleSearch = () => {
        setPage(1);
        fetchConsultationList();
    };

    const handleActionClick = (id, action) => {
        setSelectedId(id);
        setSelectedAction(action);
        setShowPopup(true);
    };
    const confirmAction = () => {
        if (!selectedId || !selectedAction) return;

        API.post("consultationStatusUpdate/update", {
            consultation_booking_id: selectedId,
            booking_status: selectedAction,
        })
            .then(() => {
                setCandidate(prev =>
                    prev.map(item =>
                        item.id === selectedId
                            ? { ...item, status: selectedAction }
                            : item
                    )
                );
                setShowPopup(false);
                setSelectedId(null);
                setSelectedAction("");
            })
            .catch((err) => {
                console.error("Failed to update status:", err);
                alert("Failed to update status.");
                setShowPopup(false);
            });
    };

    const getPopupTitle = () => {
        if (selectedAction === "Approved") return "Confirm Approval";
        if (selectedAction === "Rejected") return "Confirm Rejection";
        return "Confirm Action";
    };

    {/*
    const handleCalender = () => {
        navigate("/calender")
    }
  */}
    useEffect(() => {
        if (location.state?.pageNumber) {
            setPage(location.state.pageNumber);

            // clear state AFTER restoring
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    useEffect(() => {
        const storedLang = sessionStorage.getItem("consultationLanguageId");

        if (storedLang) {
            setLanguageId(Number(storedLang));
        }
    }, []);
    useEffect(() => {
        if (location.state?.language_id) {
            setLanguageId(location.state.language_id);
            sessionStorage.setItem(
                "consultationLanguageId",
                location.state.language_id
            );
        }

        if (location.state?.pageNumber) {
            setPage(location.state.pageNumber);
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    return (
        <div className="admin-container">
            <div className="news-header">
                <h2 className="news-title">Consultation Booking List</h2>
                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            value={languageId}
                            onChange={(e) => {
                                const lang = Number(e.target.value);
                                setLanguageId(lang);
                                setPage(1);
                                sessionStorage.setItem("consultationLanguageId", lang);
                            }}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="filter-header">
                <div className="filter-left-consultation">
                    <div className="category-filter-block1">
                        <label>Search</label>
                        <div className="input-container-consultation">
                            <input
                                placeholder="Search..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="category-input-field1"
                            />
                        </div>
                    </div>
                    <div className="filter-block">
                        <label>Immigration Type</label>
                        <div className="input-container-consultation ">
                            <select
                                value={immigration}
                                onChange={(e) => setImmigration(e.target.value)}
                                className="input-field"
                            >
                                <option value="">Select Immigration</option>
                                {immigrationType.map((cat) => (
                                    <option
                                        key={cat.listofservice_id}
                                        value={cat.listofservice_id}
                                    >
                                        {cat.heading}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="filter-block">
                        <label>Consultation Type</label>
                        <div className="input-container-consultation">
                            <select
                                value={consultation}
                                onChange={(e) => setConsultation(e.target.value)}
                                className="input-field"
                            >
                                <option value="">Select Consultation Type</option>
                                {consultationType.map((cat) => (
                                    <option
                                        key={cat.consultation_type_id}
                                        value={cat.consultation_type_id}
                                    >
                                        {cat.consultation_type_name.split(" (")[0]}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="filter-block">
                        <label>
                            {languageId === 1 ? "Status" : "Statut"}
                        </label>

                        <div className="input-container-consultation">
                            <select
                                onChange={(e) => setBookingStatusCondition(e.target.value)}
                                value={bookingStatusCondition}
                                className="input-field"
                            >
                                <option value="">
                                    {languageId === 1
                                        ? "Select Status"
                                        : "Sélectionner le statut"}
                                </option>

                                <option value="New">
                                    {languageId === 1 ? "New" : "Nouveau"}
                                </option>

                                <option value="Payment Request">
                                    {languageId === 1
                                        ? "Payment Request"
                                        : "Demande de paiement"}
                                </option>

                                <option value="Confirmed">
                                    {languageId === 1 ? "Confirmed" : "Confirmé"}
                                </option>

                            </select>

                        </div>
                    </div>

                    <div className="filter-block">
                        <label>From</label>
                        <div className="date-container-consultation">
                            <input
                                type="date"
                                value={fromDate}
                                max={toDate || undefined}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setFromDate(val);
                                    if (toDate && val > toDate) {
                                        setToDate("");
                                    }
                                }}
                                className="input-field"
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            />

                            <img
                                src={Calendar}
                                alt="Calendar"
                                className="date-icon"
                                onClick={() =>
                                    document.querySelectorAll('input[type="date"]')[0]?.showPicker?.()
                                }
                            />
                        </div>
                    </div>


                    <div className="filter-block">
                        <label>To</label>
                        <div className="date-container-consultation">
                            <input
                                type="date"
                                value={toDate}
                                min={fromDate || undefined}
                                onChange={(e) => setToDate(e.target.value)}
                                className="input-field"
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            />
                            <img
                                src={Calendar}
                                alt="Calendar"
                                className="date-icon"
                                onClick={() =>
                                    document.querySelectorAll('input[type="date"]')[1]?.showPicker?.()
                                }
                            />
                        </div>
                    </div>

                    <div className="filter-btn-wrapper mt-3" onClick={handleSearch}>
                        <img src={Search} alt="Search" className="icon-btnf" />
                    </div>
                </div>
                {/*
                <button
                    type="button"
                    className="btn calendar-btn"
                    onClick={handleCalender}
                >
                    Calendar
                </button>
                   */}
            </div>


            {/* Table */}
            <div className="admin-table-wrapper">
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <div className="admin-table-wrapper-scroll">
                            <table className="admin-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Full Name</th>
                                        <th>Email</th>
                                        <th>Mobile Number</th>
                                        <th>immigration Type</th>
                                        <th>Consultation Type</th>
                                        <th>Booking Date</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {candidate.length > 0 ? (
                                        candidate.map((item) => (
                                            <tr key={item.id}>
                                                <td>{candidate.indexOf(item) + 1}</td>
                                                <td>{item.firstName}</td>
                                                <td>{item.email}</td>
                                                <td>{item.mobile}</td>
                                                <td>{item.heading}</td>
                                                <td>{item.consultationType}</td>
                                                <td>{item.admin_date}</td>
                                                <td>{item.admin_start_time}</td>
                                                <td>{item.admin_end_time}</td>
                                                {/* <td>{item.status}</td> */}
                                                <td>
                                                    <span className={`badge  status-badge ${item.originalStatus === "Confirmed" ? "text-bg-success" : "text-bg-danger"}`} style={{ fontSize: "14px", padding: "8px 8px" }}>
                                                        {item.originalStatus === "Confirmed"
                                                            ? (languageId == 1 ? "Confirmed" : "Confirmé")
                                                            : (languageId == 1 ? "New" : "Nouveau")}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div >
                                                        {/* <img
                                                            src={AdminView}
                                                            alt="View"
                                                            className="admin-icon-btn"
                                                            onClick={() =>
                                                                navigate(`/ConsultationFromView/${item.id}`, {
                                                                    state: { pageNumber, language_id: languageId }
                                                                })
                                                            }
                                                        /> */}
                                                        <img
                                                            src={Edit}
                                                            alt="Edit"
                                                            className="admin-icon-btn"
                                                            onClick={() =>
                                                                navigate(`/OldConsultationEdit/${item.id}`, {
                                                                    state: { pageNumber, language_id: languageId }
                                                                })
                                                            }
                                                        />

                                                        {/* Show buttons ONLY if status is pending */}
                                                        {/* {item.status.toLowerCase() === "pending" && (
                                                        <>
                                                            <button
                                                                className="approve-btn"
                                                                onClick={() => handleActionClick(item.id, "Approved")}
                                                            >
                                                                Approve
                                                            </button>

                                                            <button
                                                                className="reject-btn"
                                                                onClick={() => handleActionClick(item.id, "Rejected")}
                                                            >
                                                                Reject
                                                            </button>
                                                        </>
                                                    )} */}

                                                    </div>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" style={{ textAlign: "center" }}>
                                                <p className="no-faq-text">No Booking candidate found.</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination */}
                        {totalPages > 1 && (
                            <div className="pagination-container">
                                <button
                                    className="pagination-btn"
                                    onClick={() => setPage(pageNumber - 1)}
                                    disabled={pageNumber === 1}
                                >
                                    Prev
                                </button>

                                {[...Array(totalPages)].map((_, i) => (
                                    <button
                                        key={i + 1}
                                        className={`pagination-btn ${pageNumber === i + 1 ? "active" : ""}`}
                                        onClick={() => setPage(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                ))}

                                <button
                                    className="pagination-btn"
                                    onClick={() => setPage(pageNumber + 1)}
                                    disabled={pageNumber === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        )}
                        {/*Approve and Reject Confirmation Popup */}
                        {showPopup && (
                            <div className="popup-overlay">
                                <div className="popup-box">
                                    <h3>{getPopupTitle()}</h3>

                                    <p>
                                        Are you sure you want to{" "}
                                        {selectedAction === "Approved" ? "approve" : "reject"} this booking?
                                    </p>

                                    <div className="popup-buttons">
                                        {/* Cancel always visible */}
                                        <button
                                            className="cancel-btn "
                                            onClick={() => setShowPopup(false)}
                                        >
                                            Cancel
                                        </button>

                                        {/* Show ONLY selected action */}
                                        {selectedAction === "Approved" && (
                                            <button
                                                className="btn approve-btn"
                                                onClick={confirmAction}
                                            >
                                                Approve
                                            </button>
                                        )}

                                        {selectedAction === "Rejected" && (
                                            <button
                                                className="btn reject-btn"
                                                onClick={confirmAction}
                                            >
                                                Reject
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}


                    </>
                )}
            </div>
        </div >
    );
};

export default OldConsultationFromList;
